// import Vue from 'vue';
import languageConstants from '../../constants/language-constants';
import callPathService from '../../services/api/CallPaths';
import { CALLPATHS_LOAD_ACTION, CALLPATH_STATUSES_LOAD_ACTION, CALLPATH_ARCHIVE_ACTION, CALLPATH_PROMPTS_LOAD_ACTION,
         CALLPATH_PROMPTCONNECTIONS_LOAD_ACTION, CALLPATH_UPDATE_ACTION, CALLPATH_BY_ID_ACTION, CALLPATH_ADD_PROMPT_ACTION,
         CALLPATH_REMOVE_PROMPT_ACTION, CALLPATHS_BY_PROMPTID_ACTION, CALLPATHS_REMOVE_CALLPATH_COLUMN_ACTION,
         CALLPATH_ENTITIES_LOAD_ACTION
        } from '../action-types';
import { CALLPATHS_LOAD_MUTATION, CALLPATH_STATUSES_LOAD_MUTATION, CALLPATH_ARCHIVE_MUTATION, CALLPATH_PROMPTS_LOAD_MUTATION,
         CALLPATH_PROMPTCONNECTIONS_LOAD_MUTATION, CALLPATH_SET_MAX_COLUMN_COUNT_MUTATION, CALLPATH_NAME_CHANGED_MUTATION,
         CALLPATH_VOICE_CHANGED_MUTATION, CALLPATH_SPEED_CHANGED_MUTATION, CALLPATH_STATUS_CHANGED_MUTATION,
         CALLPATH_CLEAR_DATA_MUTATION, CALLPATH_ASSIGN_MUTATION, CALLPATH_ADD_COLUMN_MUTATION, CALLPATH_REMOVE_COLUMN_MUTATION,
         CALLPATH_ADD_PROMPT_MUTATION, CALLPATH_REMOVE_PROMPT_MUTATION, CALLPATH_REARRANGE_PROMPT_MUTATION, CALLPATH_UPDATE_PROMPT_CONNECTION_MUTATION,
         CALLPATH_CLEAR_PROMPT_CONNECTION_MUTATION, CALLPATHS_BY_PROMPTID_MUTATION, CALLPATH_VALIDATE_STATUS_CHANGED_MUTATION,
         CALLPATH_CLEAR_KEY_MUTATION, CALLPATH_LOAD_CALLPATH_BY_ID_MUTATION, CALLPATH_INPUT_TIME_OUT_CHANGED_MUTATION, 
         CALLPATH_NUMBER_OF_RETRY_CHANGED_MUTATION, CALLPATH_ENTITIES_LOAD_MUTATION, CALLPATH_LANGUAGE_CHANGED_MUTATION,CALLPATH_TRANSFER_PROMPT_CHANGED_MUTATION,
         CALLPATH_SHOW_CALL_PROMPT_LIBRARY_MUTATION,CALLPATH_CREATE_TO_EDIT_MUTATION, CALLPATH_EXPAND_CALLPATH_CONNECTION_MUTATION,
         CALLPATH_AUDIT_LOG_MUTATION, CALLPATH_AUDIT_LOG_MAINTAIN_OLD_DATA_MUTATION, CALLPATH_IS_ROUTER_UPDATE_MUTATION,
         CALLPATH_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION} from '../mutation-types';

export const namespaced = true;

// initial state
export const state = {
    namespaced: true,
    callPathsData: [],
    callPathsByPromptData: [],
    callpathEntityData: [],
    callPathStatusesData: [],
    callPathPromptsData: [],
    callPathPromptConnectionsData: [],
    maxColumnCount: 5,
    isValidCallPath: false,
    callPathData: loadDefaultCallPathData(),
    showCallPromptLibrary:true,
    isCallpathCreateToEdit: false,
    expandCallPathConnection: false,
    oldCallPathData : null,
    isCallPathRouterUpdated: false
};

// actions
export const actions = {
    async [CALLPATHS_LOAD_ACTION]({ commit }) {
        const response = await callPathService.getCallPaths();
        commit(CALLPATHS_LOAD_MUTATION, response.data);
        return response;
    },
    async [CALLPATH_STATUSES_LOAD_ACTION]({ commit }) {
        const response = await callPathService.getCallPathStatuses();
        commit(CALLPATH_STATUSES_LOAD_MUTATION, response.data);
        return response;
    },
    async [CALLPATH_ARCHIVE_ACTION]({ commit }, payLoad) {
        var requestData = {callPathID: payLoad.callPathID, tazClientAuditLog: payLoad.tazClientAuditLog}
        const response = await callPathService.archiveCallPath(requestData);
        commit(CALLPATH_ARCHIVE_MUTATION, payLoad.callPathID);
        return response.data;
    },
    async [CALLPATH_PROMPTS_LOAD_ACTION]({ commit }, id) {
        const response = await callPathService.getCallPathPrompts(id);
        commit(CALLPATH_PROMPTS_LOAD_MUTATION, response.data);
        return response;
    },
    async [CALLPATH_PROMPTCONNECTIONS_LOAD_ACTION]({ commit }, id) {
        const response = await callPathService.getCallPathPromptConnections(id);
        commit(CALLPATH_PROMPTCONNECTIONS_LOAD_MUTATION, response.data);
        return response;
    },
    async [CALLPATH_UPDATE_ACTION]({ state }) {
        return await callPathService.updateCallPath(state.callPathData);
    },
    async [CALLPATHS_BY_PROMPTID_ACTION]({ commit }, id) {
        const response = await callPathService.getCallPathsByPromptID(id);
        commit(CALLPATHS_BY_PROMPTID_MUTATION, response.data);
        return response;
    },
    async [CALLPATH_BY_ID_ACTION]({ commit }, callPathId) {
        let response = await callPathService.getCallPathByID(callPathId);
        commit(CALLPATH_LOAD_CALLPATH_BY_ID_MUTATION, response.data);
        commit(CALLPATH_SET_MAX_COLUMN_COUNT_MUTATION);
    },
    [CALLPATH_ADD_PROMPT_ACTION]({ commit }, payLoad) {
        commit(CALLPATH_ADD_PROMPT_MUTATION, payLoad);
        commit(CALLPATH_REARRANGE_PROMPT_MUTATION, payLoad);
    },
    [CALLPATH_REMOVE_PROMPT_ACTION]({ commit }, payLoad) {
        if (payLoad.isRemovePrompt)
            commit(CALLPATH_CLEAR_PROMPT_CONNECTION_MUTATION, payLoad);
        commit(CALLPATH_REMOVE_PROMPT_MUTATION, payLoad);
        commit(CALLPATH_REARRANGE_PROMPT_MUTATION, payLoad);
    },
    [CALLPATHS_REMOVE_CALLPATH_COLUMN_ACTION]({commit, state}){
        let filteredCallPathPrompt = state.callPathData.callPathPrompt.filter(row => row.callPathColumn == state.maxColumnCount);
        for (let index = 0; index < filteredCallPathPrompt.length; index++) {
            let prompt = filteredCallPathPrompt[index];
            commit(CALLPATH_CLEAR_PROMPT_CONNECTION_MUTATION, { callPathColumn: prompt.callPathColumn, callPathRow: prompt.callPathRow });
        }
        commit(CALLPATH_REMOVE_COLUMN_MUTATION);
    },
    async [CALLPATH_ENTITIES_LOAD_ACTION]({ commit }) {
        const response = await callPathService.getCallPathEntities();
        commit(CALLPATH_ENTITIES_LOAD_MUTATION, response.data);
        return response;
    },
} 

// mutations
export const mutations = {
    [CALLPATHS_LOAD_MUTATION](state, callPathsData) {
        state.callPathsData = callPathsData;
    },
    [CALLPATH_STATUSES_LOAD_MUTATION](state, callPathStatusesData) {
        state.callPathStatusesData = callPathStatusesData
    },
    [CALLPATH_ARCHIVE_MUTATION](state, id) {
        var index = this.state.callPaths.callPathsData.findIndex(
            obj => obj.callPathID == id
        );
        this.state.callPaths.callPathsData[index].statusName = 'Archive';
        return this.state.callPaths.callPathsData;
    },
    [CALLPATH_PROMPTS_LOAD_MUTATION](state, callPathPromptsData) {
        state.callPathPromptsData = callPathPromptsData;
    },
    [CALLPATH_PROMPTCONNECTIONS_LOAD_MUTATION](state, callPathPromptConnectionsData) {
        state.callPathPromptConnectionsData = callPathPromptConnectionsData;
    },
    [CALLPATH_LOAD_CALLPATH_BY_ID_MUTATION](state, callPathData) {
        state.callPathData = callPathData;
        state.oldCallPathData = JSON.parse(JSON.stringify(callPathData));
    },
    [CALLPATH_SET_MAX_COLUMN_COUNT_MUTATION](state) {
        state.maxColumnCount = getMaxColumnCount();
    },
    [CALLPATH_NAME_CHANGED_MUTATION](state, callPathName) {
        state.callPathData.callPathName = callPathName;
    },
    [CALLPATH_VOICE_CHANGED_MUTATION](state, voice) {
        state.callPathData.voice = voice;
    },
    [CALLPATH_LANGUAGE_CHANGED_MUTATION](state, language) {
        state.callPathData.language = language;
        state.callPathData.voice = '';
    },
    [CALLPATH_SPEED_CHANGED_MUTATION](state, speed) {
        state.callPathData.speed = speed;
    },
    [CALLPATH_STATUS_CHANGED_MUTATION](state, status) {
        state.callPathData.statusID = status;
    },
    [CALLPATH_INPUT_TIME_OUT_CHANGED_MUTATION](state, inputTimeout) {
        state.callPathData.inputTimeout = inputTimeout;
    },
    [CALLPATH_NUMBER_OF_RETRY_CHANGED_MUTATION](state, numberOfRetry) {
        state.callPathData.numberOfRetry = numberOfRetry;
    },
    [CALLPATH_CLEAR_DATA_MUTATION](state) {
        state.callPathData = loadDefaultCallPathData();
        state.maxColumnCount = 5;
        state.isCallpathCreateToEdit = false
    },
    [CALLPATH_ASSIGN_MUTATION](state, modifiedData) {
        if (modifiedData.callPaths)
            modifiedData.callPaths[0].callPathId = modifiedData.callPathID;
        else
            modifiedData.callPaths.push({ callPathId: modifiedData.callPathID });
    },
    [CALLPATH_ADD_COLUMN_MUTATION](state) {
        state.maxColumnCount = state.maxColumnCount + 1;
    },
    [CALLPATH_REMOVE_COLUMN_MUTATION](state) {
        state.callPathData.callPathPrompt = state.callPathData.callPathPrompt.filter(row => row.callPathColumn != state.maxColumnCount);
        state.maxColumnCount = state.maxColumnCount - 1;
    },
    [CALLPATH_ADD_PROMPT_MUTATION](state, dragValue) {
        let filteredArray = state.callPathData.callPathPrompt.filter(row => row.callPathColumn == dragValue.callPathColumn);
        filteredArray.splice(dragValue.callPathRow, 0, dragValue);
        state.callPathData.callPathPrompt = state.callPathData.callPathPrompt.filter(row => row.callPathColumn != dragValue.callPathColumn);
        state.callPathData.callPathPrompt = state.callPathData.callPathPrompt.concat(filteredArray);
    },
    [CALLPATH_REMOVE_PROMPT_MUTATION](state, payLoad) {
        state.callPathData.callPathPrompt = state.callPathData.callPathPrompt.filter(row => !(row.callPathColumn == payLoad.callPathColumn && row.callPathRow == payLoad.callPathRow));
    },
    [CALLPATH_REARRANGE_PROMPT_MUTATION](state, payLoad) {
        let filteredArray = state.callPathData.callPathPrompt.filter(row => row.callPathColumn == payLoad.callPathColumn);
        for (let index = 0; index < filteredArray.length; index++) {
            filteredArray[index].callPathRow = index;
        }
    },
    [CALLPATH_UPDATE_PROMPT_CONNECTION_MUTATION](state, promptConnection) {
        let filteredArray = state.callPathData.callPathPrompt.filter(row => row.callPathColumn == promptConnection.callPathColumn);
        filteredArray.splice(promptConnection.callPathRow, 1, promptConnection);
        state.callPathData.callPathPrompt = state.callPathData.callPathPrompt.filter(row => row.callPathColumn != promptConnection.callPathColumn);
        state.callPathData.callPathPrompt = state.callPathData.callPathPrompt.concat(filteredArray);
    },
    [CALLPATH_CLEAR_PROMPT_CONNECTION_MUTATION](state, payLoad) {
        let filteredArray = state.callPathData.callPathPrompt.filter(row => !(row.callPathColumn == payLoad.callPathColumn && row.callPathRow == payLoad.callPathRow));
        let prompt = state.callPathData.callPathPrompt.filter(row => row.callPathColumn == payLoad.callPathColumn && row.callPathRow == payLoad.callPathRow);
        for (let index = 0; index < filteredArray.length; index++) {
            filteredArray[index].callPathPromptConnection.map(row => {
                if (prompt && prompt.length > 0 && row.connectingPromptID == prompt[0].promptID)
                    row.connectingPromptID = 0;
            });
        }
    },
    [CALLPATHS_BY_PROMPTID_MUTATION](state, data) {
        state.callPathsByPromptData = data
    },
    [CALLPATH_VALIDATE_STATUS_CHANGED_MUTATION](state, isValidCallPath) {
        state.isValidCallPath = isValidCallPath;
    },
    [CALLPATH_CLEAR_KEY_MUTATION](state) {
        state.callPathData.callPathID = 0;
        state.callPathData.callPathName = "Copy of " + state.callPathData.callPathName;
        state.callPathData.callPathPrompt.map(row =>{
            row.callPathID = 0; 
            row.callPathPromptID = 0;
            row.callPathPromptConnection.map(pressRow => { pressRow.callPathID = 0; pressRow.callPathPromptConnectionID = 0; })
        });
    },
    [CALLPATH_ENTITIES_LOAD_MUTATION](state, callpathEntityData) {
        state.callpathEntityData = callpathEntityData
    },
    [CALLPATH_TRANSFER_PROMPT_CHANGED_MUTATION](state, value){
        state.callPathData.whisper = value;
    },
    [CALLPATH_SHOW_CALL_PROMPT_LIBRARY_MUTATION](state, value){
        state.showCallPromptLibrary = value;
    },    
    [CALLPATH_CREATE_TO_EDIT_MUTATION](state,payLoad) {
        state.isCallpathCreateToEdit = payLoad.isCallpathCreateToEdit;
        if(payLoad.isCallpathCreateToEdit){
            state.callPathData = payLoad.response
            state.maxColumnCount = getMaxColumnCount();
        }
    },
    [CALLPATH_EXPAND_CALLPATH_CONNECTION_MUTATION](state, value) {
        state.expandCallPathConnection = value;
    },
    [CALLPATH_AUDIT_LOG_MUTATION](state, payLoad){
        state.callPathData.tazClientAuditLog = payLoad
    },
    [CALLPATH_AUDIT_LOG_MAINTAIN_OLD_DATA_MUTATION](state, value){
        state.oldCallPathData = [];
        state.oldCallPathData = value
    },
    [CALLPATH_IS_ROUTER_UPDATE_MUTATION](state, value){
        state.isCallPathRouterUpdated = value;
    },
    [CALLPATH_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION](state){
        state.oldCallPathData = null;
    },
}

export const getters = {
    maxAudioLength(){
        let maximumDuration = 0;
        for (let index = 0; index < state.maxColumnCount; index++) {
            let filteredMax = state.callPathData.callPathPrompt.filter(row=>row.callPathColumn == (index + 1));
            if(filteredMax && filteredMax.length > 0)
                maximumDuration += Math.max.apply(Math, filteredMax.map(row => { 
                    let time = row.duration.toString().split('.');
                    let minutes = parseInt(time[0]) * 60;
                    let seconds = time.length > 1 ? parseInt(time[1]) : 0;                    
                    return (minutes + seconds); 
                }));
        }
        let minutes = Math.floor(maximumDuration/60);
        let seconds = parseInt(maximumDuration - minutes * 60);
        return (minutes + '.' + seconds);
        
    }
}

function getMaxColumnCount(){
    let maxColumnCount = Math.max.apply(Math, state.callPathData.callPathPrompt.map(row => { return row.callPathColumn; }));
        return  maxColumnCount < 5 ? 5 : maxColumnCount;
}

function loadDefaultCallPathData() {
    return {
        callPathID: 0,
        callPathName: '',
        voice: '',
        language: languageConstants.ENGLISH_UNITED_STATES,
        speed: '',
        statusID: 4,
        inputTimeout:'',
        numberOfRetry:'',
        callPathPrompt: [],
        whisper: 1,
    }
}